<template>
  <div>
    <v-row no-gutters justify="center" align="start">
      <div class="ml-6 mr-6 n-container">
        <v-row no-gutters align="center" class="content-header">
          <v-btn class="n-white-btn n-small-btn px-2" @click="goToInterventions()">
            <v-icon small class="mr-2">chevron_left</v-icon>
            Retour interventions
          </v-btn>
          <v-spacer></v-spacer>
        </v-row>
        <v-row no-gutters justify="start" align="start" v-if="challengingIntervention">
          <v-col class="page-main-content">
            <intervention-card
              :value="challengingIntervention"
              is-challenging
            />
            <h3 class="mt-6 ml-1">Prestataires sondés</h3>
            <div>
              <n-card class="mt-3 py-3 px-4" v-for="(makerIntervention, i) in makersInterventions" :key="i">
                <v-row no-gutters justify="center" align="center" >
                  <v-col>
                    {{ makerIntervention.maker.name }}
                  </v-col>
                  <v-btn outlined color="green" class="mr-2" @click="goToIntervention(makerIntervention.id)">
                    <v-icon small>done</v-icon>
                  </v-btn>
                  <v-btn outlined color="red" class="mr-2" @click="goToIntervention(makerIntervention.id)">
                    <v-icon small>clear</v-icon>
                  </v-btn>
                  <v-btn outlined color="primary lighten-1" @click="goToIntervention(makerIntervention.id)">
                    <v-icon small>visibility</v-icon>
                  </v-btn>
                </v-row>
              </n-card>
            </div>
          </v-col>
          <div class="right-pane ml-6">
            <n-card>
              <n-card-header>Lieu d'intervention</n-card-header>
              <div class="px-4 pb-4 pt-1">
                <n-card-title>Client</n-card-title>
                <n-card-item>{{ challengingIntervention.client.name }}</n-card-item>
                <n-card-title>Site</n-card-title>
                <n-card-item>{{ challengingIntervention.site.name }}</n-card-item>
                <n-card-title>Adresse</n-card-title>
                <n-card-item>{{ challengingIntervention.site.address }}</n-card-item>
                <n-card-item>{{ challengingIntervention.site.postalCode }} {{ challengingIntervention.site.city }}</n-card-item>
                <n-card-title>Téléphone</n-card-title>
                <n-card-item>{{ challengingIntervention.phone1 || `-` }}</n-card-item>
              </div>
            </n-card>
            <n-card class="mt-5">
              <n-card-header class="pr-3">
                <v-row no-gutters justify="center" align="center">
                  <v-col>
                    Pièces jointes <div class="intervention-nb-indicator" v-if="!isFetchingFiles">{{ files.length }}</div>
                  </v-col>
                </v-row>
              </n-card-header>
              <div class="px-4 py-6" v-if="isFetchingFiles">
                <v-progress-linear
                  color="primary"
                  indeterminate
                  rounded
                  height="6"
                ></v-progress-linear>
              </div>
              <div class="px-4 pb-4 pt-2" v-else-if="files.length">
                <v-row no-gutters justify="start" align="center" v-for="attachment in files" :key="attachment.id" class="mt-3">
                  <v-col class="ellipsis">
                    <a :href="`https://files.nestorr.io/attachments/${attachment.uid}/${attachment.filename}`" target="_blank" class="attachment-link">
                      <font-awesome-icon :icon="[`far`, attachment.$icon]" class="attachment-icon mr-2" />
                      <div class="attachment-filename">{{ attachment.filename }}</div>
                    </a>
                  </v-col>
                  <v-chip small color="orange" outlined class="ml-2 mr-1" v-if="attachment.type === 1">Devis</v-chip>
                  <v-chip small color="green" outlined class="ml-2 mr-1" v-else-if="attachment.type === 2">Facture</v-chip>
                </v-row>
              </div>
              <div class="pa-5 font-italic" v-else>
                Aucune pièce jointe
              </div>
            </n-card>
          </div>
        </v-row>
        <v-row no-gutters justify="center" align="center" v-else>
          <div style="margin-top: 20%; width: 250px;">
            <v-progress-linear
              color="primary"
              indeterminate
              rounded
              height="6"
            ></v-progress-linear>
          </div>
        </v-row>
      </div>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import InterventionCard from '@/components/Interventions/Card.vue';

export default {
  name: `InterventionsChallengingIntervention`,

  props: [`id`],

  data: () => ({
    isFetchingFiles: false,
    challengingIntervention: null,
    makersInterventions: [],
    files: [],
  }),

  computed: {
    ...mapState(`ui/mainLayout`, [`routerTitle`]),
    challengingInterventionId() {
      return parseInt(this.id, 10);
    },
  },

  methods: {
    goToInterventions() {
      this.$router.push(`/interventions`);
    },
    goToIntervention(id) {
      this.$router.push({
        name: `InterventionsIntervention`,
        params: {
          interventionId: id,
        },
      });
    },
    async fetchChallengingIntervention() {
      const challengingIntervention = await this.$store.dispatch(`model/challengingIntervention/fetchOne`, this.challengingInterventionId);

      this.$store.commit(`ui/challengingIntervention/SET_CHALLENGING_INTERVENTION`, challengingIntervention);
      this.challengingIntervention = challengingIntervention;

      window.document.title = `${this.routerTitle} - Intervention en concurrence`;
    },

    async fetchMakersInterventions() {
      this.isFetchingMakersInterventions = true;
      const makersInterventions = await this.$store.dispatch(`model/intervention/fetchListForChallengingIntervention`, this.challengingInterventionId);
      this.isFetchingMakersInterventions = false;

      this.makersInterventions = makersInterventions;
    },
  },

  async beforeMount() {
    this.$store.commit(`ui/challengingIntervention/SET_CHALLENGING_INTERVENTION_ID`, this.interventionId);
    await Promise.all([
      this.fetchChallengingIntervention(),
      this.fetchMakersInterventions(),
      // this.fetchLinkedEquipments(),
      // this.fetchFiles(),
    ]);
  },

  components: {
    InterventionCard,
  },
};
</script>

<style lang="scss">
</style>
